import { useState, Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { PromptLibraryProvider, PromptLibraryModal } from 'app/domains/prompt-library';
import { AssistantChatKind } from 'shared/domains/apollo/generated/types';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { PopButton } from '../PopButton';
export function PromptLibraryButton(props) {
    const { disabled, onSelectPrompt } = props;
    const { addToast } = useToast();
    const [promptLibraryOpen, setPromptLibraryOpen] = useState(false);
    const isPromptLibraryAvailable = useFeatureFlag('feature_prompt_library');
    const openPromptLibrary = () => setPromptLibraryOpen(true);
    const closePromptLibrary = () => setPromptLibraryOpen(false);
    const selectPrompt = (prompt) => {
        if (prompt.kind === AssistantChatKind.Regular) {
            onSelectPrompt(prompt.content);
            closePromptLibrary();
        }
        else {
            addToast({
                title: t({
                    message: 'Please select a regular prompt, you have selected a prompt for Tabular review',
                    comment: 'Chat input - Invalid prompt selected from library',
                }),
                appearance: 'danger',
            });
        }
    };
    return (<Fragment>
      <PopButton disabled={disabled} icon={<Falcon icon="book-bookmark"/>} label={t({
            comment: 'Assistant chat dashboard - prompt library button label',
            message: 'Prompt library',
        })} onClick={openPromptLibrary}/>
      {isPromptLibraryAvailable && promptLibraryOpen && (<PromptLibraryProvider defaultView="library" onSelect={selectPrompt} onClose={closePromptLibrary}>
          <PromptLibraryModal />
        </PromptLibraryProvider>)}
    </Fragment>);
}
